<div class="text-box">
  <form [formGroup]="workflowForm">
    <textarea
      class="introduction"
      formControlName="postTone"
      placeholder="Write this in a professional tone and more concise..."
    ></textarea>
  </form>
  <div class="label-tone">Tone</div>
  <div class="tone-buttons">
    <ng-container *ngFor="let item of postTones">
      <button class="tone-button" (click)="setPostTone(item.value)">
        {{ item.key }}
      </button>
    </ng-container>
  </div>
  <button class="btn btn-primary" (click)="regenerate()">Rewrite</button>
</div>
